import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AnnouncementStatus } from '../../enums/AnnouncementStatus'

import { AnnouncementEditButtonProps } from './interface'

export const AnnouncementEditButton = ({
  uuid,
  editPath,
  record
}: AnnouncementEditButtonProps) => {
  const to = stringifyUrl({
    url: editPath,
    query: {
      id: record.id
    }
  })
  return record.status === AnnouncementStatus.SAVED ? (
    <NavigateButton to={to} uuid={uuid}>
      编辑
    </NavigateButton>
  ) : null
}
